import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-schenectady-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-schenectady-ny", statusCode: 301 });
  },
});
